export default {
	title: 'تفاصيل البصمات',

	headers: {
		enterPrint: 'بصمة دخول',
		leavePrint: 'بصمة خروج',
		duration: 'المدة',
	},

	tooltips: {
		device: 'من الجهاز',
		updated: 'تم التعديل عليها',
		inserted: 'تم الإضافة بدوياً',
	},
};
